<template>
  <div class="chart-bar">
    <el-carousel height="100%" :autoplay="false" style="width: 100%" arrow="never"
                 @change="carouselChange()">
      <el-carousel-item autoplay="false">
        <div class="chart-card">
          <div class="card-title">
            <div>广东省经济创新活力分析</div>
          </div>
          <div class="card-content">
            <div class="flex-between">
              <div></div>
              <ElementSelect
                  :val="jjhlyear"
                  :options="jjhlYearList"
                  v-model="jjhlyear"
              />
            </div>
            <div class="sub-title">
              <span>各市科创企业情况</span>
              <div>
                <ElementSelect
                    :val="dataType"
                    :options="dataTypeList"
                    @change="
                (e) => {
                  dataType = e;
                  getKC();
                }
              "
                />
                <span id="btn-link" @click="handleLink(1)">关联地图展示</span>
              </div>
            </div>
            <div class="wrapper flex-between l1-1">
              <div class="sum-box">
                <div class="sum-i i1"></div>
                <div class="sum-i i2"></div>
                <div class="sum-i i3"></div>
                <div class="sum-i i4"></div>
                <div class="sum-img"></div>
                <div class="sum-h1">广东省累计总数</div>
                <div class="sum-h2">
                  <b>{{ entData.total || '-' }}</b
                  >户
                </div>
              </div>
              <div class="sum-list">
                <div class="list-item" v-for="(item, index) in entData.list">
                  <div :class="'item-top flex-between item' + (index + 1)">
                    <div class="top-l" @click="openModal(item.city)">
                  <span>TOP {{ index + 1 }}</span
                  >{{ item.city }}
                    </div>
                    <div class="top-r">
                  <span>{{ item.count }}</span
                  >户
                    </div>
                  </div>
                  <div class="item-line">
                    <div class="line">
                      <div :style="`width:${(item.count / entData.list[0].count).toFixed(4) * 100}%;`">
                        <i></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="sub-title">
              <span>各市科技经费投入情况</span>
              <div>
                <span id="btn-link" @click="handleLink(2)">关联地图展示</span>
              </div>
            </div>
            <div class="chart-con">
              <v-chart ref="bar-chart" id="bar-chart" class="bar-chart" :options="chartOption" />
            </div>
            <div class="sub-title">
              <span>各市专利授权情况</span>
              <div>
                <span id="btn-link" @click="handleLink(3)">关联地图展示</span>
              </div>
            </div>
            <div class="chart-con">
              <v-chart ref="bar-chart2" id="bar-chart2" class="bar-chart" :options="chartOption2" />
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item autoplay="false">
        <div class="chart-card">
          <div class="card-item">
            <div class="card-title">
              <div>广东省“营商环境”评价</div>
            </div>
            <div class="card-content">
              <div class="flex-between">
                <div class="flex-between chart-ys">
                  <el-cascader
                      v-model="dataTypeYS"
                      :options="dataTypeYSList"
                      @change="
                  (e) => {
                    dataTypeYSLevel1 = e[0];
                    dataTypeYS = e.slice(-1)[0];

                  }
                "
                      :show-all-levels="false"
                  ></el-cascader>
                  <!-- <ElementSelect
                    :val="dataTypeYS"
                    :options="dataTypeYSList"
                    @change="
                      (e) => {
                        dataTypeYS = e;
                        getYsList();
                      }
                    "
                  /> -->
                </div>
                <ElementSelect
                    :val="ysYeare"
                    :options="ysYearList"
                    v-model="ysYeare"
                    class="ml12"
                />
                <!-- <span id="btn-link" @click="handleLink(4)">关联地图展示</span> -->
              </div>
              <div class="wrapper flex-between l2-1">
                <div v-if="dataTypeYSLevel1 === 2" class="list-box">
                  <div class="list-item flex-between" v-for="(item, i) in ysData">
                    <div class="item-l">
                      <b>{{ i + 1 }}</b
                      >{{ item.city }}市
                    </div>
                    <div class="item-c">
                      {{ item.position_level }}
                    </div>
                    <div :class="'item-r trend' + (item.trend === '无变化' ? 0 : item.trend === '上升' ? 1 : 2)">
                      <i>{{ item.trend === '无变化' ? '--' : '' }}</i
                      >{{ item.trend }}
                    </div>
                    <!-- <div class="item-r"><i>--</i>未变</div> -->
                  </div>
                </div>
                  <div v-if="dataTypeYSLevel1 > 2" class="list-box">
                      <div class="list-item flex-between" v-for="(item, i) in ysData2">
                          <div class="item-l">
                              <b>{{ i + 1 }}</b
                              >{{ item.second_level }}
                          </div>
                          <div class="item-l1">
                              {{ item.score }}
                          </div>
                          <div class="item-b">
                              {{ item.index_num }}
                          </div>
                          <!-- <div class="item-r"><i>--</i>未变</div> -->
                      </div>
                  </div>

                  <div v-else class="chart-con">
                  <div class="chart-box">
                    <div v-for="(bar, index) in ysData1" :class="'bar-box bar' + index">
                      <div :class="'city-box city' + index">
                        <div class="num">{{ bar.score }}</div>
                        <div class="name">{{ bar.city }}市</div>
                      </div>
                      <div
                          :class="'cube cube-' + index"
                          :style="`height: ${((bar.score / ysData1[0].score) * 0.6 * 100).toFixed(2)}%`"
                      >
                        <div class="face front"></div>
                        <div class="face right"></div>
                        <div class="face top"></div>
                      </div>
                      <div class="bar-bg">
                        <div class="bf front"></div>
                        <div class="bf right"></div>
                        <div class="bf top"></div>
                      </div>
                    </div>
                  </div>
                  <!-- <v-chart ref="bar-chart4" id="bar-chart4" class="bar-chart" :options="chartOption4" /> -->
                </div>
              </div>
            </div>
          </div>
          <div class="card-item l2-2">
            <div class="card-title">
              <div>广东省民营税收贡献</div>
            </div>
            <div class="card-content">
              <div class="flex-between">
                <div></div>
                <div>
                  <!-- <span id="btn-link" @click="handleLink(5)">关联地图展示</span> -->
                </div>
              </div>
              <div class="chart-con">
                <v-chart ref="bar-chart3" id="bar-chart3" class="bar-chart" :options="chartOption3" />
              </div>
            </div>
          </div>
          <div class="card-item l2-3">
            <div class="card-title">
              <div>广东省民营企业履行社会责任</div>
            </div>
            <div class="card-content">
              <div class="flex-between">
                <ElementSelect
                    :val="srYeare"
                    :options="srYearList"
                    v-model="srYeare"
                />
                <div>
                  <!-- <span id="btn-link" @click="handleLink(6)">关联地图展示</span> -->
                </div>
              </div>
              <div class="sub-title">
                <span>广东省民营企业参与乡村振兴(百千万工程)工作开展情况</span>
              </div>
              <FinancialService
                  ref="PrivateMigrate"
                  title="广东省万企兴万村行动开展情况"
                  name="privateTax"
                  apiName="getPrivateTax"
                  type="multi"
                  showLabel
                  :srYeare="srYeare"
                  @getSrYList="getSrYList"
              />
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <EleDialog title="企业名单" :visible.sync="showEntDialog" class="info-modal">
      <div class="filter-box">
        <ElementSelect
          :val="search.cityName"
          :options="optionCity"
          @change="
            (e) => {
              search.cityName = e;
              openModal(e);
            }
          "
          size="middle"
        />
        <EleInput v-model="search.enterpriseName" placeholder="请输入企业名称" clearable />
      </div>
      <ComTable
        :tableCol="tableColEnt"
        :tableData="tableDataEnt"
        :pager="pager"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </EleDialog>
    <EleDialog title="企业概况" :visible.sync="showCompany" class="company-profile">
      <CompModal v-if="showCompany" :curData="curData"></CompModal>
    </EleDialog>
  </div>
</template>

<script>
import drawBar from '../chartJs/chartScienceFunds';
import drawBar2 from '../chartJs/chartLicense';
import drawBar3 from '../chartJs/chartPrivateTaxes';
import FinancialService from './FinancialService.vue';
import ComTable from '../../../components/ComTable';
import CompModal from './CompModal.vue';
import TabList from '../../../components/tabList';
import MarketSubjectType from './MarketSubjectType';
import MarketMainIndustry from './MarketMainIndustry.vue';
import ElementSelect from '../../../components/element-select';
import cityJson from '../cityJson';
import { getTime } from '@/utils/tool';
export default {
  name: 'ChartBar',
  components: { ElementSelect, ComTable, TabList, MarketSubjectType, MarketMainIndustry, CompModal, FinancialService },
  props: {
    yearP: {
      type: Number,
      default: 2024,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      upIndex: 0, // 计算年份头
      downIndex: 0, // 计算年份头
      loading: true,
      loadingLine: true,
      chartOption: null,
      chartOption2: null,
      chartOption3: null,
      chartOption4: null,
      chartOptionLine: null,
      chartData: null,
      chartData2: null,
      chartData3: null,
      year: this.yearP,
      tabList: [
        {
          key: 0,
          label: '累计总数',
        },
        {
          key: 1,
          label: '本年新增',
        },
        {
          key: 2,
          label: '本年注销',
        },
      ],
      dataType: 1,
      dataTypeList: [
        {
          value: 1,
          label: '创新型中小企业',
        },
        {
          value: 2,
          label: '专精特新中小企业',
        },
        {
          value: 3,
          label: '专精特小巨人企业',
        },
        {
          value: 4,
          label: '上市民营企业',
        },
        {
          value: 5,
          label: '高新企业',
        },
      ],
      dataTypeYSLevel1: 2,
      dataTypeYS: [2],
      dataTypeYSList: [
        {
          value: 1,
          label: '明细指标评分',
          children: [],
        },
        {
          value: 2,
          label: '综合评分',
        },
      ],
        dataTypeYSList1:[],
        dataTypeYSList2:[],

        // [
      //   {
      //     value: '市场准入',
      //     label: '市场准入',
      //   },
      //   {
      //     value: '办理建筑许可',
      //     label: '办理建筑许可',
      //   },
      //   {
      //     value: '登记财产',
      //     label: '登记财产',
      //   },
      //   {
      //     value: '获得电力',
      //     label: '获得电力',
      //   },
      //   {
      //     value: '获得用水',
      //     label: '获得用水',
      //   },
      //   {
      //     value: '获得用气',
      //     label: '获得用气',
      //   },
      //   {
      //     value: '获得网络',
      //     label: '获得网络',
      //   },
      //   {
      //     value: '劳动力市场监管',
      //     label: '劳动力市场监管',
      //   },
      //   {
      //     value: '获得金融服务',
      //     label: '获得金融服务',
      //   },
      //   {
      //     value: '国际贸易',
      //     label: '国际贸易',
      //   },
      //   {
      //     value: '纳税',
      //     label: '纳税',
      //   },
      //   {
      //     value: '解决商业纠纷',
      //     label: '解决商业纠纷',
      //   },
      //   {
      //     value: '政府采购',
      //     label: '政府采购',
      //   },
      //   {
      //     value: '招标投标',
      //     label: '招标投标',
      //   },
      //   {
      //     value: '市场监管',
      //     label: '市场监管',
      //   },
      //   {
      //     value: '知识产权创造、运用和保护',
      //     label: '知识产权创造、运用和保护',
      //   },
      //   {
      //     value: '企业破产',
      //     label: '企业破产',
      //   },
      //   {
      //     value: '政务服务',
      //     label: '政务服务',
      //   },
      //   {
      //     value: '经营主体满意度',
      //     label: '经营主体满意度',
      //   },
      // ],
      ysYear: this.yearP,
        ysYeare: 0,
        srYeare: 0,
        ysYearList: [],
      yshjYearDetailOption: [],
      yshjYearOption: [],
      jjhlYearList: [],
      jjhlYearOption: [],
      jjhlyear: 0,
      ysData: null, // 综合评分数据
      ysData1: [], // 明细指标评分数据
        ysData2: [], // 明细指标评分数据
      mysjData: null,
      timer: null,
      timer2: null,
      startI: 0,
      startI2: 0,
      entData: {
        list: [],
        total: null,
      },
      statisData: null,
      tabIndex: 0,
      // yearP: null,
      options: [],
      showEntDialog: false,
      showCompany: false,
      search: {
        cityName: '佛山',
        enterpriseName: '',
      },
      optionCity: [
        // {
        //   value: '全省',
        //   label: '全省',
        // },
        ...cityJson,
      ],
      tableData: [],
      tableDataEnt: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      curData: null,
    };
  },
  created() {
    this.year = this.srYear =  new Date().getFullYear();
    this.options = [
      {
        value: this.year,
        label: this.year,
      },
    ];
    while (this.options.slice(-1)[0].value > 2021) {
      let tmp = this.options.slice(-1)[0];
      this.options.push({
        value: tmp.value - 1,
        lable: tmp.value - 1,
      });
    }
    this.srYearList = [
      {
        value: this.ysYear,
        label: this.ysYear,
      },
    ];
    // this.ysYearList = [...this.srYearList];
    // this.ysYearList = this.yshjYearOption;
    this.getInitData();
      this.getSrYList();
  },
  computed: {
    tableColEnt() {
      return [
        {
          label: '序号',
          type: 'index',
          maxWidth: 70,
        },
        {
          label: '地市',
          param: 'city',
        },
        {
          label: '企业名称',
          param: 'entname',
          fn: (x) => {
            this.showEntDialog = false;
            this.curData = { ...x, companyName: x.entname };
            this.showCompany = true;
          },
        },
      ];
    },
  },
    watch: {
        dataTypeYS(){
            this.getYsList()
        },
        ysYeare(){
            if  (this.ysYeare >= 2025) {
                this.dataTypeYSList =  this.dataTypeYSList2
                if (this.dataTypeYSLevel1 < 3) {
                    this.dataTypeYSLevel1 = 3
                    this.dataTypeYS = 3
                }
            } else {
                this.dataTypeYSList =  this.dataTypeYSList1
                if (this.dataTypeYSLevel1 > 2) {
                    this.dataTypeYSLevel1 = 2
                    this.dataTypeYS = 2
                }
            }
            this.getYsList();
        },
        dataTypeYSList1(){
            if  (this.ysYeare >= 2025) {
                this.dataTypeYSList =  this.dataTypeYSList2
                if (this.dataTypeYSLevel1 < 3) {
                    this.dataTypeYSLevel1 = 3
                    this.dataTypeYS = 3
                }
            } else {
                this.dataTypeYSList =  this.dataTypeYSList1
                if (this.dataTypeYSLevel1 > 2) {
                    this.dataTypeYSLevel1 = 2
                    this.dataTypeYS = 2
                }
            }
        },
        dataTypeYSList2(){
            if  (this.ysYeare >= 2025) {
                this.dataTypeYSList =  this.dataTypeYSList2
                if (this.dataTypeYSLevel1 < 3) {
                    this.dataTypeYSLevel1 = 3
                    this.dataTypeYS = 3
                }
            } else {
                this.dataTypeYSList =  this.dataTypeYSList1
                if (this.dataTypeYSLevel1 > 2) {
                    this.dataTypeYSLevel1 = 2
                    this.dataTypeYS = 2
                }
            }
        },
        jjhlyear(){
            this.getData();
        },
        dataType(){
            this.getInitData();
        },
        year() {
            this.$nextTick(() => {});
        },
        'search.enterpriseName'(n) {
            if (!n) {
                this.search.enterpriseName = null;
            }
            this.pager.currentPage = 1;
            this.$nextTick(() => this.openModal());
        },
        showCompany(n) {
            if (!n) this.curData = null;
        },
        upIndex(n) {
            if (this.downIndex + n > 3) return;
            if (this.downIndex + n === 3) {
                // console.log("55555555"+this.year)
                // if (n === 0) {
                //   this.options = this.options.filter((x) => x.value !== this.year);
                //   this.year = this.options[0].value;
                // } else if (n !== 3) {
                //   this.year--;
                // }
                // console.log("55555555"+this.year)
                this.getData();
            }
        },
        downIndex(n) {
            if (this.upIndex + n > 3) return;
            if (this.upIndex + n === 3) {
                // if (n === 3) {
                //   this.options = this.options.filter((x) => x.value !== this.year);
                //   this.year = this.options[0].value;
                // } else if (n !== 0) {
                //   this.year--;
                // }
                this.getData();
            }
        },
    },
    methods: {
        handleLink(index) {
            this.$emit('handleLink', {
                index,
                dataType: this.dataType,
                year: this.jjhlyear,
            });
        },
        getInitData(){
            this.$api.market.getJjHlYearOption({dataType: this.dataType}).then((res) => {
                this.jjhlYearOption = res.data.data.data;
                this.jjhlyear = this.jjhlYearOption[0];
                this.jjhlYearList = []
                for (let key in this.jjhlYearOption) {
                    this.jjhlYearList.push(
                        {
                            value: this.jjhlYearOption[key],
                            lable: this.jjhlYearOption[key],
                        }
                    );
                }

            });

            this.$api.market.getYshjOption().then((res) => {
                let { firstLevel } = res.data.data;
                this.dataTypeYSList[0].children = firstLevel.map((x) => {
                    for (const key in x) {
                        if (Object.hasOwnProperty.call(x, key)) {
                            const e = x[key];
                            let second = e
                                .filter((y) => y !== '/')
                                .map((z) => ({
                                    label: z,
                                    value: z,
                                }));
                            return {
                                label: key,
                                value: key,
                                children: second.length ? second : undefined,
                            };
                        }
                    }
                });

                this.dataTypeYSList1 = this.dataTypeYSList;
                this.dataTypeYSList2 =  [

                    {
                        value: 3,
                        label: '市场环境',
                    },
                    {
                        value: 4,
                        label: '法治环境',
                    },
                    {
                        value: 5,
                        label: '创新环境',
                    },
                    {
                        value: 6,
                        label: '政务环境',
                    },
                ]
            });
        },
        getKC() {


            // this.jjhlYearList = []
            // for (let key in this.jjhlYearOption) {
            //   this.jjhlYearList.push(
            //           {
            //             value: this.jjhlYearOption[key],
            //             lable: this.jjhlYearOption[key],
            //           }
            //   );
            // }


            // 各市科创企业情况
            this.$api.market
                .getEntData({
                    dataType: this.dataType,
                    year: this.jjhlyear,
                })
                .then((res) => {
                    let { data } = res.data;
                    this.entData = data;
                    if (data.list.length) this.upIndex++;
                    else this.downIndex++;
                });

            // 各市科技经费投入情况
            this.$api.market
                .getKjjfCity({
                    year: this.jjhlyear,
                })
                .then((res) => {
                    let { data } = res.data;
                    let listData = [];
                    if (data && data.funds?.length) {
                        this.upIndex++;
                        data.funds.map((x) => {
                            let t1 = x.city.replace(/\s+/g, '');
                            let tmp = data.porportion.find((y) => {
                                let t2 = y.city.replace(/\s+/g, '');
                                let tmp2 = listData.find((z) => z.city === t1);
                                return tmp2 ? false : t1 === t2;
                            });
                            if (tmp) listData.push({ porportion: tmp.proportion, city: t1, funds: x.funds });
                        });
                    } else this.downIndex++;
                    let list = {
                        yAxis: {
                            names: ['单位：亿元', ''],
                        },
                        names: ['R&D经费', 'R&D经费占地区生产总值'],
                        data: listData,
                        grid: {
                            top: '23%',
                        },
                        legend: {
                            top: -5,
                        },
                    };
                    this.chartData = list;
                    this.updateChart();
                    this.chartAuto();
                    // this.chartOption = drawBar(list);
                });
            //各市专利授权情况
            this.$api.market
                .getZlsqCity({
                    year: this.jjhlyear,
                })
                .then((res) => {
                    let { data } = res.data;
                    let listData = [];
                    if (data && data.invent?.length) {
                        this.upIndex++;
                        data.invent.map((x) => {
                            let tmp = data.design.find((y) => y.city === x.city),
                                tmp2 = data.utility.find((y) => y.city === x.city),
                                tmp3 = listData.find((y) => y.city === x.city);
                            if (!tmp3) {
                                listData.push([x.city, x.invent, tmp2.utility, tmp.design]);
                            }
                        });
                    } else this.downIndex++;
                    let list = {
                        yAxis: {
                            names: ['单位：亿元', ''],
                        },
                        names: ['发明', '实用新型', '外观设计'],
                        data: listData,
                        isStack: true,
                    };
                    this.chartData2 = list;
                    // this.chartOption2 = drawBar2(list);
                    this.updateChart2();
                    this.chartAuto2();
                });
        },
        getData() {
            // this.$api.market.getJjHlYearOption({dataType: 1}).then((res) => {
            //   this.jjhlYearOption = res.data.data.data;
            //   console.log("jjhlyear", this.jjhlyear)
            //   if (this.jjhlyear === 0) {
            //     this.jjhlyear = this.jjhlYearOption[0];
            //   }
            // });
            this.$api.market.getYshjYearOption({dataType: 2}).then((res) => {
                this.yshjYearDetailOption = res.data.data.data;

            });
            // this.$api.market.getYshjYearOption({dataType: 1}).then((res) => {
            //     this.yshjYearDetailOption = res.data.data.data;
            //
            // });
            // this.$api.market.getYshjYearOption({dataType: 0}).then((res) => {
            //     this.yshjYearOption  = res.data.data.data;
            //
            // });

            this.getKC();
            // let chart = echarts.init(document.getElementById('bar-chart'));

            this.getYsList();
            // 广东省民营税金贡献
            this.$api.market
                .getSsgxDetail({
                    endYear: this.yearP,
                })
                .then((res) => {
                    let { data } = res.data.data;
                    let list = {
                        yAxis: {
                            names: ['单位：亿元', '%'],
                        },
                        names: ['全省税收', '民营税收', '民营占比'],
                        data,
                    };
                    this.chartData3 = list;
                    this.chartOption3 = drawBar3(list);
                });
        },
        // 广东省“营商环境”评价
        getYsList() {
            this.getYsYList();
            if (this.dataTypeYSLevel1 === 1) {
                this.$api.market
                    .getYshjCity({
                        dataType: this.dataTypeYS,
                        year: this.ysYeare,
                    })
                    .then((res) => {
                        let { data } = res.data.data;
                        if (data.length) {
                            this.ysData1 = data;
                            // this.getYsYList();
                        } else {
                            // if (this.ysYear > 2021) {
                            //   this.ysYear--;
                            //   this.getYsList();
                            // }
                        }
                        // this.ysData = data.data.slice(0, 5);
                    });
            } else if(this.dataTypeYSLevel1 === 2) {
                this.$api.market
                    .getYshjData({
                        year: this.ysYeare,
                    })
                    .then((res) => {
                        let { data } = res.data.data;
                        if (data.length) {
                            this.ysData = data;
                            // this.getYsYList();
                        } else {
                            // if (this.ysYear > 2021) {
                            //   this.ysYear--;
                            //   this.getYsList();
                            // }
                        }

                        // this.ysData = data.data.slice(0, 5);
                    });
            } else {
                this.$api.market
                    .getYshjDetail({
                        year: this.ysYeare,
                        dataType: this.dataTypeYS
                    })
                    .then((res) => {
                        let { data } = res.data.data;
                        if (data.length) {
                            this.ysData2 = data;
                            // this.getYsYList();
                        }
                    });
            }
        },
        getYsYList() {

            if (true) {
                this.ysYearList = []
                // this.ysYearList = this.yshjYearDetailOption;
                for (let key in this.yshjYearDetailOption) {
                    this.ysYearList.push(
                        {
                            value: this.yshjYearDetailOption[key],
                            lable: this.yshjYearDetailOption[key],
                        }
                    );
                }
            } else if (this.dataTypeYSLevel1 === 1) {
                this.ysYearList = []
                // this.ysYearList = this.yshjYearDetailOption;
                for (let key in this.yshjYearDetailOption) {
                    this.ysYearList.push(
                        {
                            value: this.yshjYearDetailOption[key],
                            lable: this.yshjYearDetailOption[key],
                        }
                    );
                }
            } else {
                // this.ysYearList = this.yshjYearOption;
                this.ysYearList = []
                for (let key in this.yshjYearOption) {
                    this.ysYearList.push(  {
                        value: this.yshjYearOption[key],
                        lable: this.yshjYearOption[key],
                    });
                }
            }
            if (this.ysYeare === 0) {
                this.ysYeare = this.ysYearList[0].value
            }

        },
        getSrYList(e) {

            this.$api.market.getTyYearOption({dataType: 'fulfilling_social_responsibility_statistics'}).then((res) => {
                this.srYearOption = res.data.data.data;
                // console.log("yearE", this.yearE)
                if (this.srYeare === 0) {
                    this.srYeare = this.srYearOption[0];
                    this.srYearList = []
                    for (let key in this.srYearOption) {
                        this.srYearList.push(
                            {
                                value: this.srYearOption[key],
                                lable: this.srYearOption[key],
                            }
                        );
                    }
                }
            });

            // this.srYear = e;
            // if (this.srYearList.length <= 1) {
            //   this.srYearList = [
            //     {
            //       value: this.srYear,
            //       lable: this.srYear,
            //     },
            //   ];
            //   while (this.srYearList.slice(-1)[0].value > 2021) {
            //     let tmp = this.srYearList.slice(-1)[0];
            //     this.srYearList.push({
            //       value: tmp.value - 1,
            //       lable: tmp.value - 1,
            //     });
            //   }
            // }
        },
        chartAuto() {
            if (this.timer) clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.startI = this.startI + 1 < this.chartData.data.length ? this.startI + 1 : 0;
                this.updateChart();
            }, 4100);
        },
        chartAuto2() {
            if (this.timer2) clearInterval(this.timer2);
            this.timer2 = setInterval(() => {
                this.startI2 = this.startI2 + 1 < this.chartData2.data.length ? this.startI2 + 1 : 0;
                this.updateChart2();
            }, 4100);
        },
        updateChart() {
            let max = this.chartData.data.length;
            let endI = this.startI + 9;
            let list = [];
            if (endI < max) {
                list = this.chartData.data.slice(this.startI, endI);
            } else
                list = [...this.chartData.data.slice(this.startI, max), ...this.chartData.data.slice(0, 9 - max + this.startI)];
            this.chartOption = drawBar({
                ...this.chartData,
                data: list,
            });
        },
        updateChart2() {
            let max = this.chartData2.data.length;
            let endI = this.startI2 + 9;
            let list = [];
            if (endI < max) {
                list = this.chartData2.data.slice(this.startI2, endI);
            } else
                list = [
                    ...this.chartData2.data.slice(this.startI2, max),
                    ...this.chartData2.data.slice(0, 9 - max + this.startI2),
                ];
            list.unshift(['invent', 'utility', 'design']);
            this.chartOption2 = drawBar2({
                ...this.chartData2,
                data: list,
            });
        },
        getEntList() {
            this.$api.market
                .getEntList({
                    dataType: this.dataType,
                    year: this.jjhlyear,
                    city: this.search.cityName,
                    entName: this.search.enterpriseName,
                    pageNum: this.pager.currentPage,
                    pageSize: 10,
                })
                .then((res) => {
                    this.tableDataEnt = [];
                    this.tableDataEnt = res.data.data.records;
                    this.pager.total = res.data.data.total;
                });
        },
        openModal(e) {
            this.showEntDialog = true;
            if (e) this.search.cityName = e;
            this.getEntList();
        },
        handleSizeChange(e) {
            this.pager.pageSize = e;
            this.getEntList();
        },
        handleCurrentChange(e) {
            this.pager.currentPage = e;
            this.getEntList();
        },
    },
    mounted() {
        this.getData();
        this.getEntList();
    },
};

</script>

<style lang="less" scoped>
.ml12 {
  margin-left: 12px;
}
.chart-bar {
  .chart-box();
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  justify-content: space-between;
  .chart-card {
    width: 100%;
    height: 95%;
    display: flex;
    flex-direction: column;
    .card-item {
      + .card-item {
        margin-top: 25px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
    }
    .chart-ys {
      position: relative;
      /deep/ .el-cascader {
        // position: absolute;
        // top: 0;
        // left: 0;
        width: 130px;
        .el-input--suffix .el-input__inner {
          height: 28px;
          // padding-left: 44px;
          background: linear-gradient(
            0deg,
            rgba(0, 197, 250, 0.5) 0%,
            rgba(0, 197, 250, 0.48) 6%,
            rgba(0, 197, 250, 0.11) 100%
          );
          border-radius: 3px;
          border: none;
        }

        input {
          background: linear-gradient(
            0deg,
            rgba(0, 197, 250, 0.5) 0%,
            rgba(0, 197, 250, 0.48) 6%,
            rgba(0, 197, 250, 0.11) 100%
          );
          outline: none;
          border: none;
          color: #fff;
          font-size: 14px;
        }
      }
    }
    .l2-2 .card-content,
    .l2-3 .card-content {
      flex: 1;
    }
    .card-title {
      width: 100%;
      height: 36px;
      background: url('~img/market/market-card-title.png') no-repeat;
      background-size: 100% 100%;
      padding-left: 17px;
      box-sizing: border-box;
      div {
        font-family: 'AlibabaPB';
        font-weight: bold;
        font-size: 25px;
        color: #ffffff;
        line-height: 36px;
        // text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
        font-style: italic;
        background: linear-gradient(
          180deg,
          rgba(189, 232, 247, 1) 0%,
          rgba(191, 229, 252, 1) 20%,
          rgba(249, 253, 254, 1) 58.7646484375%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .card-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-top: 2px;
      margin: -1px 1px 1px;
      background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
      border-radius: 4px;
      border: 1px solid;
      border-image: linear-gradient(0deg, rgba(154, 234, 255, 0.15), rgba(154, 234, 255, 0.15)) 1 1;
      border-top: none;
      .chart-con {
        .chart-box {
          // width: 100%;
          height: 100%;
          overflow-x: scroll;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          // padding: 0 20px;
          .bar-box {
            position: relative;
            width: 28px;
            height: 100%;
            padding: 0 8.3%;
            &:after {
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translateX(-50%);
              width: 68px;
              height: 76px;
              content: '';
              background: url('~img/market/bar-bottom.png') center center no-repeat;
              background-size: cover;
            }
            &.bar0:after {
              background: url('~img/market/bar-bottom1.png') center center no-repeat;
              background-size: cover;
            }
            &.bar1:after {
              background: url('~img/market/bar-bottom2.png') center center no-repeat;
              background-size: cover;
            }
            &.bar2:after {
              background: url('~img/market/bar-bottom3.png') center center no-repeat;
              background-size: cover;
            }
          }
          .city-box {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            .num {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 14px;
              color: #ffffff;
              white-space: nowrap;
              &.city-0 {
                background: linear-gradient(0deg, #f63d01 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.city-1 {
                background: linear-gradient(0deg, #f48f00 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.city-2 {
                background: linear-gradient(0deg, #82f40e 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
            .name {
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 12px;
              color: #fdffff;
              white-space: nowrap;
            }
          }
          .bar-bg {
            width: 20px;
            height: 144px;
            position: absolute;
            left: 50%;
            bottom: 16px;
            transform-style: preserve-3d;
            transform: translateX(-50%) rotateX(-30deg) rotateY(-45deg);
            .bf {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.9);
              box-sizing: border-box;
              &.front {
                transform: translateZ(10px);
                background: linear-gradient(to top, rgba(2, 26, 28, 0), rgba(24, 72, 117, 0.96));
              }
              &.right {
                transform: rotateY(90deg) translateZ(10px);
                background: linear-gradient(to bottom, rgba(24, 72, 117, 1), rgba(4, 61, 66, 0.3));
              }
              &.top {
                height: 20px;
                transform: rotateX(90deg) translateZ(10px);
                background: rgba(24, 72, 117, 0.6);
              }
            }
          }
          .cube {
            width: 20px;
            height: 100px;
            position: absolute;
            left: 50%;
            bottom: 16px;
            transform-style: preserve-3d;
            transform: translateX(-50%) rotateX(-30deg) rotateY(-45deg);
            z-index: 9;
            // animation: rotate 5s infinite linear;
            .face {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.9);
              // border: 2px solid #ccc;
              box-sizing: border-box;

              &.front {
                transform: translateZ(10px);
                background: linear-gradient(to top, #1960b6, #3988ff);
              }
              // .back {
              //   transform: rotateY(180deg) translateZ(10px);
              //   background: linear-gradient(to right, #45a29e, #66bfa6);
              // }
              &.right {
                transform: rotateY(90deg) translateZ(10px);
                background: linear-gradient(to bottom, #072975, #1748c1);
              }
              // .left {
              //   transform: rotateY(-90deg) translateZ(10px);
              //   background: linear-gradient(to top, #ff6f61, #ffcc5c);
              // }
              &.top {
                height: 20px;
                transform: rotateX(90deg) translateZ(10px);
                background: #5dc9ff;
                // linear-gradient(to right, #ffcc5c, #ff6f61);
              }
              // .bottom {
              //   transform: rotateX(-90deg) translateZ(10px);
              //   background: linear-gradient(to left, #66bfa6, #45a29e);
              // }
            }
            &.cube-0 {
              .front {
                background: linear-gradient(to top, #d1602b, #ffaf83);
              }
              .right {
                background: linear-gradient(to bottom, #b1440e, #742111);
              }
              .top {
                background: #ff7c3a;
                // linear-gradient(to right, #ffcc5c, #ff6f61);
              }
            }
            &.cube-1 {
              .front {
                background: linear-gradient(to top, #ffc76e, #ffe6bf);
              }
              .right {
                background: linear-gradient(to bottom, #ac670d, #fed423);
              }
              .top {
                background: #ffcd7e;
              }
            }
            &.cube-2 {
              .front {
                background: linear-gradient(to top, #19a6b0, #00c67e);
              }
              .right {
                background: linear-gradient(to bottom, #07646a, #01b575);
              }
              .top {
                background: #60f9cc;
              }
            }
          }
        }
      }
    }
  }
  .wrapper {
    padding: 0 10px;
    * {
      box-sizing: border-box;
    }
  }
  .l1-1 {
    padding-top: 13px;
    padding-bottom: 28px;
    .sum-box {
      position: relative;
      width: 167px;
      height: 218px;
      padding: 28px 0;
      margin-right: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: rgba(50, 98, 190, 0.11);
      border-top: 2px dashed rgba(104, 230, 255, 0.2);
      border-bottom: 2px dashed rgba(104, 230, 255, 0.2);
      .sum-i {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid #68e6ff;
        &.i1 {
          left: -1px;
          top: -2px;
          border-right: none;
          border-bottom: none;
        }
        &.i2 {
          right: -1px;
          top: -2px;
          border-left: none;
          border-bottom: none;
        }
        &.i3 {
          left: -1px;
          bottom: -2px;
          border-right: none;
          border-top: none;
        }
        &.i4 {
          right: -1px;
          bottom: -2px;
          border-left: none;
          border-top: none;
        }
      }
      .sum-img {
        width: 100px;
        height: 87px;
        background: url('~img/market/market-l-sum.png') no-repeat;
        background-size: 100% 100%;
      }
      .sum-h1 {
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        font-size: 18px;
        color: rgba(216, 226, 255, 0.8);
        line-height: 1;
        font-style: italic;
        margin: 20px;
      }
      .sum-h2 {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: rgba(239, 240, 241, 0.6);
        line-height: 1;
        b {
          margin-right: 8px;
          font-family: YouSheTitle;
          font-weight: 400;
          font-size: 26px;
          color: #e4edf7;
        }
      }
    }
    .sum-list {
      flex: 1;
      height: 100%;
      max-height: 218px;
      overflow-y: scroll;
      .list-item {
        + .list-item {
          margin-top: 18px;
        }
        .item-top {
          &.item1 {
            .top-l span {
              color: #fb3c00;
            }
            .top-r span {
              background: linear-gradient(0deg, #f63d01 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item2 {
            .top-l span {
              color: #fa9300;
            }
            .top-r span {
              background: linear-gradient(0deg, #f48f00 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item3 {
            .top-l span {
              color: #7ffc00;
            }
            .top-r span {
              background: linear-gradient(0deg, #82f40e 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item4 {
            .top-l span {
              color: #49acff;
            }
            .top-r span {
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          .top-l {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 20px;
            color: #ffffff;
            span {
              font-family: Myriad Pro;
              font-weight: 400;
              font-size: 16px;
              color: #49acff;
              margin-right: 19px;
            }
          }
          .top-r {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 18px;
            color: #d8e2ff;
            font-style: italic;
            span {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 20px;
              color: #ffffff;
              font-style: italic;
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              padding-right: 3px;
              margin-right: 4px;
            }
          }
        }
        .item-line {
          width: 100;
          height: 16px;
          background: rgba(16, 28, 52, 0.5);
          padding: 5px 4px;
          margin-top: 2px;
          .line {
            position: relative;
            width: 100%;
            height: 4px;
            background: #0a284a;
            border-radius: 2px;
            div {
              position: absolute;
              left: 0;
              top: -1px;
              width: 80%;
              height: 6px;
              background: linear-gradient(270deg, #51b0ff 0%, rgba(0, 120, 255, 0) 100%);
              border-radius: 2px;
              i {
                position: absolute;
                right: 0;
                top: -2px;
                width: 10px;
                height: 10px;
                display: inline-block;
                background: #e3f2ff;
                box-shadow: 0 0 7px rgba(227, 242, 255, 1);
                border-radius: 50%;
              }
            }
          }
        }
      }
    }
  }
  .l2-1 {
    .list-box {
      width: 100%;
      height: 253px;
      padding: 17px 0 8px;
      overflow-y: scroll;
      .list-item {
        width: 100%;
        height: 38px;
        border-radius: 4px;
        border: 1px solid #2b97ff;
        padding: 0 39px 0 36px;
        + .list-item {
          margin-top: 5px;
        }
          .item-l {
              font-family: Source Han Sans CN;
              font-weight: bold;
              font-size: 14px;
              color: #ffffff;
              line-height: 24px;
              display: inline-flex;
              width: 60%;
              /*align-items: center;*/
              /*justify-content: center;*/
              b {
                  width: 26px;
                  text-align: center;
                  font-family: Geometr706 BlkCn BT;
                  font-weight: 900;
                  font-size: 22px;
                  color: #00c9ff;
                  font-style: italic;
                  background: linear-gradient(0deg, #ffffff 0%, #baf0ff 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  margin-right: 22px;
              }
          }
          .item-l1 {
              font-family: Source Han Sans CN;
              font-weight: bold;
              width: 50px;
              font-size: 14px;
              color: #ffffff;
              line-height: 24px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              b {
                  width: 26px;
                  text-align: center;
                  font-family: Geometr706 BlkCn BT;
                  font-weight: 900;
                  font-size: 22px;
                  color: #00c9ff;
                  font-style: italic;
                  background: linear-gradient(0deg, #ffffff 0%, #baf0ff 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  margin-right: 22px;
              }
          }

          .item-c {
          height: 20px;
          padding: 0 13px;
          background: rgba(252, 245, 194, 0.2);
          border-radius: 2px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 19px;
          color: #fcf5c2;
          line-height: 20px;
        }
          .item-b {
              height: 20px;
              padding: 0 13px;
              background: rgba(8, 17, 30, 0.2);
              border: 1px solid #0078ff;
              border-radius: 2px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              font-size: 12px;
              color: #288dff;
              line-height: 20px;
          }

          .item-r {
          width: 80px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 19px;
          color: #dcdcdc;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          i {
            width: 12px;
            height: 12px;
            line-height: 12px;
            font-family: Geometr706 BlkCn BT;
            font-size: 20px;
            color: #dcdcdc;
            font-style: normal;
            margin-right: 11px;
            white-space: nowrap;
          }
          &.trend1 {
            background: linear-gradient(-7deg, #ffca00 0%, #ff5a00 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            i {
              background: url('~img/market/ys-up.png') center center no-repeat;
              background-size: cover;
            }
          }
          &.trend2 {
            background: linear-gradient(0deg, #19490a 0.9033203125%, #7cfa00 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            i {
              background: url('~img/market/ys-down.png') center center no-repeat;
              background-size: cover;
            }
          }
        }
      }
    }
  }
  .chart-content {
    position: relative;
    flex: 1;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    padding: 56px 0 0 17px;
    // border: NaNpx solid;
    border-image: linear-gradient(180deg, #071322, #225087) 10 10;
    background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
    border-radius: 4px;
  }
  /deep/ .po {
    margin: 0;
    height: 0;
    .list {
      position: absolute;
      top: 12px;
      left: 19px;
      right: unset;
    }
  }
  .chart-statistics {
    position: relative;
    background: rgba(1, 20, 48, 0.08);
    border: 2px solid rgba(#095194, 0.2);
    padding: 17px 91px 13px 29px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    i {
      position: absolute;
      top: 0;
      left: 0;
      width: 9px;
      height: 4px;
      background: #7af0fc;
      &.i2 {
        left: 14px;
        opacity: 0.6;
        &.r {
          right: 14px;
        }
      }
      &.i3 {
        left: 27px;
        opacity: 0.2;
        &.r {
          right: 27px;
        }
      }
      &.r {
        left: unset;
        right: 0;
      }
    }
    .item-title {
      position: relative;
      height: 21px;
      perspective: 50px;
      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: attr(data-title);
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #eff0f1;
        line-height: 24px;
        padding-left: 10px;
        white-space: nowrap;
      }
      &::before {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 211px;
        height: 20px;
        background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
        content: '';
        display: block;
        transform: rotateX(24deg);
        perspective-origin: right top;
      }
    }
    .span-label,
    .span-num {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 19px;
    }
    .span-num {
      color: #ff6a6a;
      margin-right: 0;
    }
    .stat-left .span-num {
      padding-left: 44px;
      font-size: 24px;
      font-weight: 900;
      color: #6acbff;
      line-height: 38px;
    }
    .span-unit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #eff0f1;
      line-height: 29px;
      opacity: 0.6;
      margin-left: 10px;
    }
    .div-i {
      width: 16px;
      height: 16px;
      margin-right: 9px;
      display: inline-block;
      background: url('~img/commonImg/chart-stat.png') no-repeat;
      background-size: 100% 100%;
    }
    .stat-center,
    .stat-right {
      display: inline-flex;
      align-items: center;
      &.des {
        .div-i {
          transform: rotate(180deg);
        }
        .span-num {
          color: rgba(88, 236, 172, 1);
        }
      }
    }
  }
  .sub-title {
    padding: 20px 9px 13px 10px;
    font-size: 23px;
    color: #eff0f1;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    position: relative;
    &::before {
      width: 100%;
      height: 18px;
      content: ' ';
      display: block;
      position: absolute;
      bottom: 20px;
      left: 10px;
      background: linear-gradient(90deg, rgba(#0083ad, 1) 0%, rgba(#0083ad, 0) 40%);
      z-index: -1;
      transform: skewX(-40deg);
    }
    // &::after {
    //   width: 0;
    //   height: 0;
    //   content: ' ';
    //   display: block;
    //   position: absolute;
    //   position: absolute;
    //   bottom: 20px;
    //   left: 10px;
    //   border: 20px solid transparent;
    //   border-left-color: #000;
    // }
    span {
      padding-left: 20px;
    }
    div {
      display: inline-flex;
      line-height: 1;
      align-items: center;
    }
    #btn-link {
      margin-left: 12px;
    }
  }
  .chart-con {
    flex: 1;
    height: 198px;
    /deep/ .echarts > div {
      max-height: 100%;
      canvas {
        height: 100% !important;
      }
    }
  }
  .left-bottom {
    display: flex;
    > div {
      width: calc(50% - 13px);
      &:first-of-type {
        margin-right: 26px;
      }
      /deep/ .title {
        white-space: nowrap;
        width: 100%;
        #btn-link {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      /deep/ .flex-between {
        height: 52px;
      }
    }
  }
  /deep/ .ele-dialog {
    z-index: 9999;
    &.info-modal {
      z-index: 999;
      .item-title {
        position: relative;
        perspective: 100px;
        margin-bottom: 28px;
        height: 25px;
        &::after {
          position: absolute;
          left: 0;
          bottom: 0;
          content: attr(data-title);
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #eff0f1;
          line-height: 24px;
          padding-left: 10px;
        }
        &.YouSheTitle::after {
          font-family: 'YouSheTitle';
          font-weight: 400;
          font-size: 26px;
        }
        &::before {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 20px;
          background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
          content: '';
          display: block;
          transform: rotateX(8deg);
          perspective-origin: right top;
        }
      }

      .item-content {
        width: 100%;
        height: auto !important;
        align-items: flex-start;
        box-sizing: border-box;
        border-image: linear-gradient(180deg, #071322, #225087) 10 10;
        // background: linear-gradient(
        //   90deg,
        //   rgba(38, 69, 103, 0.4) 0%,
        //   rgba(61, 110, 167, 0.4) 47%,
        //   rgba(38, 69, 103, 0.4) 100%
        // );
        border-radius: 4px;
        margin-bottom: 41px;
        padding: 23px 20px 31px 41px;
        ul.content-ul {
          padding: 0;
          margin: 0;
          list-style: none;
          max-width: calc(100% / 3);

          + ul {
            position: relative;
            padding-left: 43px;
            &::before {
              position: absolute;
              left: 0;
              top: 0;
              width: 2px;
              height: 100%;
              background: #2c4c73;
              box-shadow: 1px 0px 2px 0px rgba(20, 34, 51, 0.5);
              content: '';
              display: inline-block;
            }
          }
          li {
            display: flex;
          }
          .li-label {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #dcdcdc;
            line-height: 30px;
            margin-right: 22px;
            text-wrap: nowrap;
          }
          .li-value {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;
          }
        }
      }
    }

    &.company-profile .el-dialog {
      width: 2144px;
      height: 806px;
      .el-dialog__body {
        padding: 0;
        height: calc(100% - 55px);
        .item-content {
          // padding: 0;
        }
      }
    }
  }
}
</style>
